import download from "downloadjs";

export function downloadPDFByGet(apiObj: any, url: string, fileName: string) {
  apiObj.get(url, { responseType: "blob" }).then((response) => {
    const content = response.headers["content-type"];
    download(response.data, fileName + ".pdf", content);
  });
}

export function downloadPDFByPost(
  apiObj: any,
  url: string,
  body: any,
  fileName: string
) {
  apiObj.post(url, body).then((response) => {
    const linkSource = `data:application/pdf;base64,${response.data.value.result}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  });
}

export function maxNumber(maxLength: number){
  return (e)=>{
    e = e || window.event;
    var charCode = typeof e.which == "undefined" ? e.keyCode : e.which;
    var charStr = String.fromCharCode(charCode);
  
    if (!charStr.match(/^[0-9]+$/) || e.target.value.length >= maxLength) e.preventDefault();
  }
}
